<template>
  <div :class="['thumbnail-grid', { centered }]">
    <div :class="['thumbnail-wrapper', { centered }]">
<template v-for="(group, index) in groupedVisibleItems">
        <div :key="'section-' + index" class="content-section">
          <!-- Überschrift für den jeweiligen Block -->
          <h3 class="section-title">{{ group.title }}</h3>

          <!-- Kacheln dieses Blocks -->
          <div class="section-tiles">
            <tile
              v-for="item in group.items"
              :key="item.itemID"
              :item="item"
              ref="thumbnails"
            />
          </div>
        </div>
      </template>
    <tile
      v-if="itemsCount > visibleCount"
      :item="null"
    />
    </div>
    <div ref="loadTrigger" class="load-trigger"></div> <!-- Unsichtbarer Trigger fürs Nachladen -->
  </div>
</template>

<script>
import tile from "./tile.vue";
import { getBibTitle, getDepictionLabel, getCaveLabel, getCaveShortLabel, getWallLabels } from "../utils/helpers";

export default {
  components: { tile },
  props: {
    items: Array, // Gesamtmenge an Bildern
    itemsCount: Number,
    centered: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      processedItems: [],
      visibleCount: 20, // Starte mit 20 Bildern
      observer: null,
      steps: 20
    };
  },
  computed: {
visibleProcessedItems() {
      return this.processedItems.slice(0, this.visibleCount);
    },
    groupedVisibleItems() {
      const result = [];
      let currentGroupType = null;
      let currentItems = [];

      for (const item of this.visibleProcessedItems) {
        const type = item.itemType === 'iconography' ? 'iconography' : 'other';

        if (type !== currentGroupType) {
          if (currentItems.length == 1) {
            result.push({
              type: currentGroupType,
              title: currentGroupType === 'iconography'
                ? 'Kucha Murals Thesaurus Keyword'
                : 'Information System Entry',
              items: currentItems
            });
          } else if (currentItems.length > 0) {
            result.push({
              type: currentGroupType,
              title: currentGroupType === 'iconography'
                ? 'Kucha Murals Thesaurus Keywords'
                : 'Information System Entries',
              items: currentItems
            });
          }
          currentGroupType = type;
          currentItems = [item];
        } else {
          currentItems.push(item);
        }
      }

      // Letzten Block hinzufügen
      if (currentItems.length == 1) {
        result.push({
          type: currentGroupType,
          title: currentGroupType === 'iconography'
            ? 'Kucha Murals Thesaurus Keyword'
            : 'Information System Entry',
          items: currentItems
        });
      } else  if (currentItems.length > 0) {
        result.push({
          type: currentGroupType,
          title: currentGroupType === 'iconography'
            ? 'Kucha Murals Thesaurus Keywords'
            : 'Information System Entry',
          items: currentItems
        });
      }
      return result;
    },
    visibleItems() {
      return this.processedItems.slice(0, this.visibleCount); // Zeige nur die geladenen Bilder an
    },
  },
  mounted() {
    this.$log.debug("lazyTileGrid mounted", this.items);
    this.processItems(true);
    this.initObserver();
  },
  methods: {
getSubTitle(item) {
      if (item.depictionID && item.cave) {
        return getCaveShortLabel(item.cave, "") + ",  " + getWallLabels(item, "");
      }
      return null;
    },





    // --- BESTEHENDE BILD-/ANNOTATIONS-METHODEN ---
    getDepictionLabel(pr){
      if (Object.keys(pr).length > 0){
        return getDepictionLabel(pr)
      }
      return ""
    },
    getMasterImage(pr){
      const images = pr.relatedImages ? pr.relatedImages : pr.images
      for (const image of images) {
        if (image.imageID === pr.masterImageID) {
          return image;
        }
      }
      return null

    },
    getPreselectedAnnotations(pr){
      if (pr.highlightedAnnotations)
      {
        const filteredAnnotations = pr.highlightedAnnotations.filter((anno) => anno.w3c.length > 0)
        this.$log.debug("getPreselectedAnnotations found highlightedAnnotations", filteredAnnotations.map(anno => JSON.parse(anno.w3c)))
        return filteredAnnotations.map(anno => {
            var w3cAnno = JSON.parse(anno.w3c)
            w3cAnno["motivation"] = "highlight"
            return { "w3c":w3cAnno, annotationID: anno.annotationID }
          }
        )
      }
      let annotations = []
      this.$log.debug("getPreselectedAnnotations", pr)
      const masterImage = this.getMasterImage(pr)
      if (masterImage){
        for (let annotation of pr.relatedAnnotationList){
          this.$log.debug("getPreselectedAnnotations annotation", annotation, "of depiction", pr.depictionID)
          if (annotation.image === masterImage.filename){
            let found = false

            for (let tag of annotation.tags){
              if (!pr.preSelected) break;
              for (let preselectedIco of pr.preSelected){
                if (tag.iconographyID === preselectedIco.iconographyID){
                  let w3cAnno =  JSON.parse(annotation.w3c) // clone annotation
                  w3cAnno["motivation"] = "highlight"
                  annotations.push(w3cAnno)
                  found = true
                  break;
                }
              }
              if (found) break;
            }

          }
        }
      }
      if (annotations.length === 0) {
        if (pr.masterAnnotation) {
          const masterAnno = pr.relatedAnnotationList.find(
            (anno) => anno.annotoriousID === pr.masterAnnotation
          );
          this.$log.debug("looking for masterannotation", pr.masterAnnotation)
          if (masterAnno) {
            if (masterAnno.image === masterImage.filename){
              this.$log.debug("found masterannotation", masterAnno)
              let w3cAnno =  JSON.parse(masterAnno.w3c) // clone annotation
              w3cAnno["motivation"] = "highlight"
              annotations.push(w3cAnno)

            }
          }

        }
      }
      return annotations
    },
processItems(startNew) {
      this.$log.debug("processItems", this.items);
      if (!startNew) {
        this.processedItems = []
      }
      let processedItem = null
      for (const item of this.items) {
        if (item) {
          // NEU: Wir berechnen Highlight und Subtitle hier
          const highlightHtml = item.highlighted;
          const subTitle = this.getSubTitle(item);
          if (item.depictionID) {
            const preSelected = item.highlightedAnnotations ? item.highlightedAnnotations : this.getPreselectedAnnotations(item)
            processedItem = {
              label: (item.cave === undefined || item.shortName === "")
                      ? "Painted Representation " + item.depictionID
                      : "Painted Representation " + item.depictionID + " (" + item.shortName + ")",
              subTitle: subTitle,
              highlight: highlightHtml,
              itemID: item.depictionID,
              itemType: "pr",
              masterImage: this.getMasterImage(item),
              preSelected: preSelected.map(anno => anno.w3c ? anno.w3c : anno),
              link: "/pr/" + item.depictionID + "?" + (preSelected ? "&annotation=" + preSelected.map(anno => anno.annotationID).join(",") : "")
            };
          } else if (item.caveID) {
            processedItem = {
              label: 'Cave ' + getCaveLabel(item),
              subTitle: subTitle,
              highlight: highlightHtml,
              itemID: item.caveID,
              itemType: "cave",
              masterImage: item.caveSketchList[0],
              preSelected: [],
              link: "/cave/" + item.caveID
            };
          } else if (item.iconographyID) {
            const preSelected = item.highlightedAnnotations ? item.highlightedAnnotations : this.getPreselectedAnnotations(item)
            processedItem = {
              label: "Keyword: " + item.text,
              subTitle: subTitle,
              highlight: highlightHtml,
              itemID: item.iconographyID,
              itemType: "iconography",
              masterImage: item.oe ? this.getMasterImage(item.oe) : null,
              preSelected: preSelected.map(anno => anno.w3c ? anno.w3c : anno),
              link: "/iconography/" + item.iconographyID
            };
          } else if (item.annotatedBibliographyID) {
            processedItem = {
              label: "Annotated Bibliography: " + getBibTitle(item),
              subTitle: subTitle,
              highlight: highlightHtml,
              itemID: item.annotatedBibliographyID,
              itemType: "bibliography",
              masterImage: null,
              preSelected: null,
              link: "/bibliography/" + item.annotatedBibliographyID
            };
          }

          if (this.processedItems.find((i) => i.itemID === processedItem.itemID)) {
            continue;
          } else {
            this.processedItems.push(processedItem);
          }
        }
      }
    },
    initObserver() {
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.loadMoreImages();
        }
      });

      if (this.$refs.loadTrigger) {
        this.observer.observe(this.$refs.loadTrigger);
      }
    },
    loadMoreImages() {
      if (this.visibleCount < this.itemsCount) {
        this.$emit("loadMore", this.visibleCount, this.steps);
        this.visibleCount += this.steps;
      }
    },
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }

  },

  watch: {
    items() {
      if (this.processedItems.length > 0) {
        this.processItems(false);
      }
    },
  }
};
</script>

<style>
.thumbnail-grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.thumbnail-grid.centered {
  justify-content: center;
  flex: 1 1 100%;
}

.thumbnail-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;

  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;

  overflow-y: auto;
}

.thumbnail-wrapper.centered {
  overflow-y: auto;
}

.content-section {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 15px;
  text-align: center;
  letter-spacing: 0.5px;
}

.section-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(220px, 100%), 1fr));
  gap: 10px;

  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;

  padding: 0 5px;
  justify-items: center;
}

.load-trigger {
  height: 1px;
  width: 100%;
  flex-shrink: 0;
}
</style>